import { render, staticRenderFns } from "./UnpaidWarning.vue?vue&type=template&id=e48ff472"
import script from "./UnpaidWarning.vue?vue&type=script&lang=js"
export * from "./UnpaidWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports